import { constants } from "../constants";
import { StringFormat } from "../Util/stringutil";
import {
  InsertBranch,
  InsertBranchResponse,
  ReadBranchDetails,
} from "./entity/BranchOperationEntity";
import { GenericStatus, Status } from "./entity/Status";
import { myFetch } from "./myFetch";

// Interface for the Corporation API calls...
export default interface IBranchOperation {
  getBranchAsync(corpId: number): Promise<Status<ReadBranchDetails[]>>;
  getBranchByIdAsync(
    corpId: number,
    branchId: number,
  ): Promise<ReadBranchDetails>;
  postBranchAsync(
    corpId: number,
    request: InsertBranch,
  ): Promise<Status<InsertBranchResponse>>;
  putBranchAsync(
    corpId: number,
    branchId: number,
    request: InsertBranch,
  ): Promise<GenericStatus>;
}

export class BranchOperation implements IBranchOperation {
  async putBranchAsync(
    corpId: number,
    branchId: number,
    request: InsertBranch,
  ): Promise<GenericStatus> {
    const response = await myFetch<Status<InsertBranchResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.PUT_BRANCH,
        corpId,
        branchId,
      )}`,
      {
        method: "PUT",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(request),
      },
    );

    const data = await response.json();
    return data;
  }
  // Insert Branch.
  async postBranchAsync(
    corpId: number,
    request: InsertBranch,
  ): Promise<Status<InsertBranchResponse>> {
    const response = await myFetch<Status<InsertBranchResponse>>(
      `${constants.BASE_URL}${StringFormat(constants.POST_BRANCH, corpId)}`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(request),
      },
    );

    const data = await response.json();
    return data;
  }

  // Get Branch Detail By Id.
  async getBranchByIdAsync(
    _corpId: number,
    _branchId: number,
  ): Promise<ReadBranchDetails> {
    void _corpId;
    void _branchId;
    throw new Error("Method not implemented.");
  }

  // Get Corpration detail by Id..
  async getBranchAsync(corpId: number): Promise<Status<ReadBranchDetails[]>> {
    const response = await myFetch<Status<ReadBranchDetails[]>>(
      `${constants.BASE_URL}${StringFormat(constants.GET_ALL_BRANCH, corpId)}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      },
    );

    const data = await response.json();
    return data;
  }
}
